import script from "./mutualFund.vue?vue&type=script&setup=true&lang=js"
export * from "./mutualFund.vue?vue&type=script&setup=true&lang=js"

import "./mutualFund.vue?vue&type=style&index=0&id=e23ae772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e23ae772"]])

export default __exports__